<template>
  <IconLucidePrinter />
</template>
